import { render, staticRenderFns } from "./ThirdPartySecretKey.vue?vue&type=template&id=67d09c98&scoped=true"
import script from "./ThirdPartySecretKey.vue?vue&type=script&lang=js"
export * from "./ThirdPartySecretKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d09c98",
  null
  
)

export default component.exports